module.exports = __webpack_public_path__ + "img/pdf_1.b114c0c1.png";